import { sctvPages, affiliatePages, dlpoPages } from "@/constants/constant";
import { getAccountIdLambdaInvoke } from "@/utils/LambdaHelper";

export function setSctvTag(pageId) {
  let page = pageId.toUpperCase();
  let parent = document.getElementById("sctv");
  parent.innerHTML = "";
  let target = sctvPages.filter((item) => {
    return item.page === page;
  });
  if (target.length > 0) {
    let src = target[0]["src"];
    let tag = document.createElement("script");
    tag.setAttribute("src", src);
    parent.appendChild(tag);
  }
}

export function pushOnesData(page, res) {
  window.odtag("config", 75294, { send_page_view: false }); // eslint-disable-line
  if (page === "TEM001") {
    window.odtag("event", "conversion", {
      event_category: "apply_upload",
      order_id: res,
    }); // eslint-disable-line
  }
  if (page === "TEM006") {
    window.odtag("event", "conversion", {
      event_category: "apply_account",
      order_id: res,
    }); // eslint-disable-line
  }
}

export function setAffiliateTag(pageId) {
  let page = pageId.toUpperCase();
  let parent = document.getElementById("userid");
  parent.innerText = "";
  if (affiliatePages.indexOf(page) !== -1) {
    getAccountIdLambdaInvoke().then((res) => {
      parent.innerText = res;
      // アドエビスの計測アカウントにデータ送信
      window.ebis = window.ebis || []; // eslint-disable-line
      window.ebis.push({
        // eslint-disable-line
        argument: "y9e2GWzK",
        member_name: parent.innerText,
        amount: "",
        other1: "",
        other2: "sid",
        other3: "",
        other4: "",
        other5: "", // eslint-disable-line
      }); // eslint-disable-line
      // ワンズデータの計測アカウントにデータ送信
      setTimeout(function onesData() {
        try {
          pushOnesData(page, res);
        } catch (e) {
          setTimeout(function onesData() {
            pushOnesData(page, res);
          }, 1000);
        }
      }, 1000);
    });
  }
}

export function setDlpoTag(pageId) {
  let page = pageId.toUpperCase();
  let parent = document.getElementById("dlpo");
  parent.innerHTML = "";
  let target = dlpoPages.filter((item) => {
    return item.page === page;
  });
  if (target.length > 0) {
    let dom = target[0]["dom"];
    parent.innerHTML = dom;

    let src = target[0]["src"];
    let oneCodeTag = document.createElement("script");
    oneCodeTag.setAttribute("src", src);
    oneCodeTag.setAttribute("type", "text/javascript");
    parent.appendChild(oneCodeTag);

    let cvTag = document.createElement("script");
    let script = target[0]["script"];
    cvTag.innerHTML = script;
    cvTag.setAttribute("type", "text/javascript");
    parent.appendChild(cvTag);
  }
}

export function launchApp(host) {
  let scheme = process.env.VUE_APP_APP_SCHEME;
  let store = "https://itunes.apple.com/jp/app/id1455810848?mt=8";
  let androidPackage = process.env.VUE_APP_APP_SCHEME.replace("-", "_");
  let site = "https://loan.kddi-fs.com/";
  let userAgent = navigator.userAgent.toLowerCase();

  const stopPopUpWindow = (appUrl, storeUrl) => {
    window.location.href = appUrl;
    const time = new Date().getTime();
    setTimeout(function () {
      const now = new Date().getTime();
      if (now - time > 400) {
        // 元の画面に戻ってきた時にポップアップを抑制するため
        return;
      }

      const confirmOpenAppStore = confirm(
        "アプリが開かない場合、アプリストアを開きますか？"
      );
      if (confirmOpenAppStore) {
        window.location.href = storeUrl;
      }
    }, 300);
  };

  // iPhone端末ならアプリを開くかApp Storeを開く。
  if (userAgent.search(/iphone|ipod/) > -1) {
    const IPHONE_URL_SCHEME = scheme + "://" + host;
    stopPopUpWindow(IPHONE_URL_SCHEME, store);
    return false;
  } else if (userAgent.search(/android/) > -1) {
    // Android端末ならアプリを開くかGoogle Playを開く。
    document.location =
      "intent://" +
      host +
      "#Intent;scheme=" +
      scheme +
      ";package=" +
      androidPackage +
      ";end";
  } else {
    // その他・不明・PCなどの場合はサイトを開く。
    location.href = site;
  }
}
